import { Card, Grid, Skeleton } from "@mui/material";

const StudioCardSkeleton = () => <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
    <Card sx={{
        height: 320,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        pb: 2
    }}>
        <Skeleton variant="rounded" width="inherit" height="200px" sx={{ borderRadius: 0 }} />
        <Skeleton sx={{ alignSelf: "center" }} variant="rounded" width="90%" height="32px" />
        <Skeleton sx={{ alignSelf: "center" }} variant="rounded" width="120px" height="40px" />
    </Card>
</Grid>

export default StudioCardSkeleton;